{
  "privacy": {
    "sections": {
      "dataRetention": {
        "bodyHtml": "<p>We retain personal information only for as long as necessary to provide our services, meet contractual obligations, resolve disputes and comply with legal requirements.</p><p>When information is no longer required, it is securely deleted or anonymized.</p>"
      },
      "security": {
        "bodyHtml": "<p>We take reasonable technical and organizational measures to protect your information against unauthorized access, loss, misuse or disclosure.</p><p>No online service can guarantee absolute security, but we continually review and improve our security practices.</p>"
      }
    }
  },
  "terms": {
    "sections": {
      "userResponsibilities": {
        "bodyHtml": "<p>You agree to:</p><ul><li>Provide accurate and up-to-date information when creating or using your account.</li><li>Keep your login credentials secure.</li><li>Use the application only for its intended purpose.</li><li>Comply with any applicable laws and regulations.</li></ul><p>You must not:</p><ul><li>Attempt to gain unauthorized access to the application or its systems.</li><li>Interfere with or disrupt the operation or security of the application.</li><li>Use the application for fraudulent, unlawful or malicious purposes.</li></ul>"
      }
    }
  }
}
